import { breakpointSizes } from 'components/utils/breakpoint'
import type { MapPadding } from 'lib/maps/types'
import { getWidth } from 'lib/window/getViewport'

interface ResponsivePaddingConfig {
  desktop: MapPadding
  mobile: MapPadding
}

/**
 * Camera fit padding used when focusing the map on markers or destination bounds.
 * Values are one pixel smaller than the design padding to avoid the map zooming out
 * one extra level due to rounding when the fitted bounds should match the viewport.
 */
export const searchResultsMapCameraPaddingConfig: ResponsivePaddingConfig = {
  desktop: { top: 66, left: 59, bottom: 39, right: 59 },
  mobile: { top: 69, left: 19, bottom: 47, right: 19 },
}

export function getResponsiveSearchResultsMapPadding(config: ResponsivePaddingConfig): MapPadding {
  if (getWidth() >= breakpointSizes.tablet.min) {
    return config.desktop
  }

  return config.mobile
}

export function getPadding(): MapPadding {
  return getResponsiveSearchResultsMapPadding(searchResultsMapCameraPaddingConfig)
}
